/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharestatusrejected2Inputs */

const en_sharestatusrejected2 = /** @type {(inputs: Sharestatusrejected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not counted`)
};

const de_sharestatusrejected2 = /** @type {(inputs: Sharestatusrejected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nicht gezählt`)
};

/**
* | output |
* | --- |
* | "not counted" |
*
* @param {Sharestatusrejected2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharestatusrejected2 = /** @type {((inputs?: Sharestatusrejected2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharestatusrejected2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharestatusrejected2(inputs)
	return de_sharestatusrejected2(inputs)
});
export { sharestatusrejected2 as "shareStatusRejected" }